import { Pipe, PipeTransform } from '@angular/core';
import {
  GbGrundstueckListEntryMeta,
  GrundstueckDetailEntryMeta,
  GrundstueckListEntry,
  GrundstueckListEntryMeta
} from '../../../core/gb-api';
import { TranslateService } from '@ngx-translate/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { TranslateNamePipe } from './translate-name.pipe';
import GrundstueckArtEnum = GrundstueckListEntryMeta.GrundstueckArtEnum;
import SdrArtEnum = GrundstueckDetailEntryMeta.SdrArtEnum;

@Pipe({
  name: 'grundstueckArt',
  pure: false
})
export class GrundstueckArtPipe implements PipeTransform {
  constructor(
    private translateService: TranslateService,
    private translateMultiLanguage: TranslateNamePipe
  ) {
    keysToTranslate(['STR', 'CFA', 'DPI', 'VEC', 'VIC', 'ADG', 'FOLIO', 'BERGWERK']);
  }

  transform(entry: GrundstueckListEntry | GbGrundstueckListEntryMeta | GrundstueckDetailEntryMeta, languageChangeEvent = 'de'): string {
    if (entry.ligArt) {
      return this.liegenschaftUnterartKurz(entry);
    }
    return this.grundstueckArtKurz(entry.grundstueckArt, entry.sdrArt);
  }

  private grundstueckArtKurz(value: GrundstueckArtEnum, sdrArt: SdrArtEnum): string {
    switch (value) {
      case 'LIEGENSCHAFT':
        return this.translateService.instant('LIG');
      case 'STOCKWERK':
        return this.translateService.instant('STW');
      case 'MITEIGENTUM':
        return this.translateService.instant('MIT');
      case 'UNBEKANNT':
        return this.translateService.instant('UNB');
      case 'SDR':
        if (sdrArt) {
          return this.translateService.instant('SDR') + ' (' + this.translateService.instant(sdrArt) + ')';
        }
        return this.translateService.instant('SDR');
      default:
        return this.translateService.instant(value);
    }
  }

  private liegenschaftUnterartKurz(entry: GrundstueckListEntry | GbGrundstueckListEntryMeta | GrundstueckDetailEntryMeta): string {
    switch (entry.ligArt) {
      case 'STR':
        return this.translateService.instant('STR');
      case 'UEBRIGEART':
        if (entry.codeUnterart) {
          return this.translateMultiLanguage.transform(entry.codeUnterart.text);
        }
        return this.translateService.instant('LIG');
      default:
        return this.translateService.instant(entry.ligArt);
    }
  }
}
